module.exports = __webpack_public_path__ + "static/media/Final_logo.af2a98ab.jpg";